import { Fragment } from 'react';

import { FilterPill } from '@zola/zola-ui/src/components/FilterPill';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';

import { useSearchResultsPageContext } from '~/pages/couples/explore/components/SearchResults/contexts/SearchResultsPageContext';
import { useVendorSearchNavigation } from '~/pages/couples/explore/components/SearchResults/contexts/VendorSearchNavigationContext';
import { createVendorSearchFromFilters } from '~/pages/couples/explore/util/createVendorSearchFromFilters';
import { OptionFacetType } from '~/types/types';
import { formatDate } from '~/util/dateUtils';

import styles from './SearchTags.module.less';

export type SearchTagsProps = {
  clearFilters: () => void;
};
export const SearchTags = (props: SearchTagsProps) => {
  const { clearFilters } = props;
  const { selectedFacetOptions, vendorSearch } = useSearchResultsPageContext();
  const { navigateToSrp } = useVendorSearchNavigation();

  const setSelectedFitlers = (options: OptionFacetType[]) =>
    navigateToSrp(createVendorSearchFromFilters(options));

  const handleClick = (facetValue: OptionFacetType) => {
    const filteredRequestFacets = selectedFacetOptions.filter(
      (facet) => facetValue.slug !== facet.slug
    );
    setSelectedFitlers(filteredRequestFacets);
  };

  const handleDateClick = (removeDate: string) => {
    navigateToSrp({
      availabilityDates: vendorSearch.availabilityDates?.filter((date) => date !== removeDate),
    });
  };

  const hasSelectedTags =
    selectedFacetOptions.length !== 0 || vendorSearch?.availabilityDates?.length !== 0;

  if (!hasSelectedTags) {
    return <Fragment />;
  }

  return (
    <div className={styles.searchTags}>
      <div className={styles.facetWrapper}>
        {selectedFacetOptions &&
          selectedFacetOptions.map((facetOption) => (
            <FilterPill
              className={styles.facetTag}
              handlePillClick={() => handleClick(facetOption)}
              key={facetOption.key || facetOption.displayName}
            >
              {facetOption.tagName || facetOption.displayName || facetOption.name}
            </FilterPill>
          ))}
        {vendorSearch?.availabilityDates &&
          vendorSearch.availabilityDates.map((date) => (
            <FilterPill
              className={styles.facetTag}
              handlePillClick={() => handleDateClick(date)}
              key={date.toString()}
            >
              Available on {formatDate(date, 'MMMM D, YYYY')}
            </FilterPill>
          ))}

        {hasSelectedTags && (
          <LinkV2
            className={styles.clearAll}
            role="button"
            type="button"
            variant="primary"
            onClick={clearFilters}
          >
            Clear
          </LinkV2>
        )}
      </div>
    </div>
  );
};
